import * as React from 'react';

import { AdvantageItem } from './components/AdvantageItem';
import * as styles from './styles.css';
import { IAdvantage } from '../../types/newobject/newbuildingAdvantages';
import { CardSectionNew } from '../CardSectionNew';
import { VerticalSliderFullscreen } from '../VerticalSlider';

interface IAdvantagesProps {
  advantages: IAdvantage[];
  detailsButton: React.ReactNode;
  onItemClick(i: number): void;
}

export function Advantages({ advantages, detailsButton, onItemClick }: IAdvantagesProps) {
  return (
    <CardSectionNew title="Особенности жилого комплекса">
      <div className={styles['slider-wrapper']}>
        <VerticalSliderFullscreen onItemClick={onItemClick}>
          {advantages.map(({ title, images }) => (
            <AdvantageItem key={title} title={title} imgUrl={images[0]?.url} counter={images.length} />
          ))}
        </VerticalSliderFullscreen>
      </div>
      {detailsButton}
    </CardSectionNew>
  );
}
